function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin, Messaging } from 'oskari-ui/util';
import { showCoordinatePopup } from './CoordinatePopup';
import { PLACEMENTS } from 'oskari-ui/components/window';
import { getTransformedCoordinates, transformCoordinates, isTransformAllowed as _isTransformAllowed } from './helper';
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(plugin, mapModule, config) {
    var _this$config$reverseG;
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this.plugin = plugin;
    _this.sandbox = Oskari.getSandbox();
    _this.loc = Oskari.getMsg.bind(null, 'coordinatetool');
    _this.mapModule = mapModule;
    _this.config = config;
    var coordinateToolService = Oskari.clazz.create('Oskari.mapframework.bundle.coordinatetool.CoordinateToolService', _this.sandbox, config || {});
    _this.sandbox.registerService(coordinateToolService);
    _this.service = coordinateToolService;
    _this.mapProjection = _this.mapModule.getProjection();
    _this.isReverseGeoCode = _this.config.isReverseGeocode;
    _this.reverseGeocodingIds = (_this$config$reverseG = _this.config.reverseGeocodingIds) === null || _this$config$reverseG === void 0 ? void 0 : _this$config$reverseG.split(',');
    _this.setState({
      xy: {},
      latField: '',
      lonField: '',
      loading: false,
      showMouseCoordinates: false,
      selectedProjection: _this.mapProjection,
      emergencyInfo: null,
      reverseGeocodeNotImplementedError: false,
      reverseGeoCode: [],
      showReverseGeoCode: false,
      approxValue: false
    });
    _this.popupControls = null;
    _this.eventHandlers = _this.createEventHandlers();
    _this.decimalSeparator = Oskari.getDecimalSeparator();
    _this.popupListeners = [];
    _this.addStateListener(function () {
      return _this.updatePopup();
    });
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "addPopupListener",
    value: function addPopupListener(func) {
      this.popupListeners.push(func);
    }
  }, {
    key: "notifyPopupListeners",
    value: function notifyPopupListeners(isOpen) {
      this.popupListeners.forEach(function (func) {
        return func(isOpen);
      });
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'CoordinatePluginHandler';
    }
  }, {
    key: "popupCleanup",
    value: function popupCleanup() {
      if (this.popupControls) this.popupControls.close();
      this.popupControls = null;
      this.notifyPopupListeners(false);
    }
  }, {
    key: "updatePopup",
    value: function updatePopup() {
      if (this.popupControls) {
        this.popupControls.update(this.state);
      }
    }
  }, {
    key: "setLoading",
    value: function setLoading(status) {
      this.updateState({
        loading: status
      });
    }
  }, {
    key: "toggleMouseCoordinates",
    value: function toggleMouseCoordinates() {
      this.updateState({
        showMouseCoordinates: !this.state.showMouseCoordinates
      });
    }
  }, {
    key: "toggleReverseGeoCode",
    value: function toggleReverseGeoCode() {
      this.updateState({
        showReverseGeoCode: !this.state.showReverseGeoCode
      });
    }
  }, {
    key: "setLonInputValue",
    value: function setLonInputValue(value) {
      this.updateState({
        lonField: value
      });
    }
  }, {
    key: "setLatInputValue",
    value: function setLatInputValue(value) {
      this.updateState({
        latField: value
      });
    }
  }, {
    key: "isTransformAllowed",
    value: function isTransformAllowed() {
      if (typeof this.__transformAllowed !== 'undefined') {
        return this.__transformAllowed;
      }
      var supportedProjections = this.config.supportedProjections;
      this.__transformAllowed = _isTransformAllowed(supportedProjections);
      return this.__transformAllowed;
    }

    // prefer proj specific and default to global format
  }, {
    key: "getProjectionShowFormat",
    value: function getProjectionShowFormat() {
      var _this$config, _this$config2;
      var selectedProj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.selectedProjection;
      var projection = selectedProj || this.mapProjection;
      var projConfig = ((_this$config = this.config) === null || _this$config === void 0 || (_this$config = _this$config.projectionShowFormat) === null || _this$config === void 0 ? void 0 : _this$config[projection]) || {};
      var globalFormat = (_this$config2 = this.config) === null || _this$config2 === void 0 || (_this$config2 = _this$config2.projectionShowFormat) === null || _this$config2 === void 0 ? void 0 : _this$config2.format;
      return projConfig.format || globalFormat;
    }

    // prefer proj specific, global format, deprecated conf and default to mapmodule logic
  }, {
    key: "getProjectionDecimals",
    value: function getProjectionDecimals() {
      var _conf$projectionShowF, _conf$projectionShowF2;
      var selectedProj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.selectedProjection;
      var projection = selectedProj || this.mapProjection;
      var conf = this.config;
      var projConfig = (conf === null || conf === void 0 || (_conf$projectionShowF = conf.projectionShowFormat) === null || _conf$projectionShowF === void 0 ? void 0 : _conf$projectionShowF[projection]) || {};
      var globalFormat = conf === null || conf === void 0 || (_conf$projectionShowF2 = conf.projectionShowFormat) === null || _conf$projectionShowF2 === void 0 ? void 0 : _conf$projectionShowF2.decimals;
      var decimalCount = projConfig.decimals || globalFormat;
      if (typeof decimalCount === 'number' && decimalCount >= 0) {
        return decimalCount;
      }
      var deprecatedConf = conf === null || conf === void 0 ? void 0 : conf.roundToDecimals;
      if (deprecatedConf) {
        Oskari.log('coordinatetool').warn('Deprecated coordinatetool.conf.roundToDecimals - please use coordinatetool.conf.projectionShowFormat.decimals or ' + 'coordinatetool.conf.projectionShowFormat["projection"].decimals instead.');
        if (typeof deprecatedConf === 'number' && deprecatedConf >= 0) {
          return conf.roundToDecimals;
        }
      }
      return this.mapModule.getProjectionDecimals(projection);
    }
  }, {
    key: "useUserDefinedCoordinates",
    value: function () {
      var _useUserDefinedCoordinates = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, isDegrees, converted;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                lonlat: {
                  lon: this.formatNumber(this.state.lonField, '.'),
                  lat: this.formatNumber(this.state.latField, '.')
                }
              }; // Check if format should be degrees and add '°' symbol if needed
              isDegrees = this.getProjectionShowFormat() === 'degrees';
              if (isDegrees) {
                if (data.lonlat.lon.indexOf('°') < 0) data.lonlat.lon = data.lonlat.lon + '°';
                if (data.lonlat.lat.indexOf('°') < 0) data.lonlat.lat = data.lonlat.lat + '°';
              }
              _context.next = 5;
              return this.convertCoordinates(data, this.state.selectedProjection, this.mapProjection);
            case 5:
              converted = _context.sent;
              this.updateLonLat(converted, true, true, true);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function useUserDefinedCoordinates() {
        return _useUserDefinedCoordinates.apply(this, arguments);
      }
      return useUserDefinedCoordinates;
    }()
  }, {
    key: "coordinatesToMetric",
    value: function coordinatesToMetric(data) {
      var _data$lonlat, _data$lonlat2;
      var converted = Oskari.util.coordinateDegreesToMetric([(_data$lonlat = data.lonlat) === null || _data$lonlat === void 0 ? void 0 : _data$lonlat.lon, (_data$lonlat2 = data.lonlat) === null || _data$lonlat2 === void 0 ? void 0 : _data$lonlat2.lat], 10);
      return {
        lonlat: {
          lon: converted[0],
          lat: converted[1]
        }
      };
    }
  }, {
    key: "isMapCentered",
    value: function isMapCentered() {
      var _mapXy$lonlat, _this$state$xy, _mapXy$lonlat2, _this$state$xy2;
      var mapXy = this.getMapXY();
      if ((mapXy === null || mapXy === void 0 || (_mapXy$lonlat = mapXy.lonlat) === null || _mapXy$lonlat === void 0 ? void 0 : _mapXy$lonlat.lon) === ((_this$state$xy = this.state.xy) === null || _this$state$xy === void 0 || (_this$state$xy = _this$state$xy.lonlat) === null || _this$state$xy === void 0 ? void 0 : _this$state$xy.lon) && (mapXy === null || mapXy === void 0 || (_mapXy$lonlat2 = mapXy.lonlat) === null || _mapXy$lonlat2 === void 0 ? void 0 : _mapXy$lonlat2.lat) === ((_this$state$xy2 = this.state.xy) === null || _this$state$xy2 === void 0 || (_this$state$xy2 = _this$state$xy2.lonlat) === null || _this$state$xy2 === void 0 ? void 0 : _this$state$xy2.lat)) {
        return true;
      }
      return false;
    }
  }, {
    key: "popupLocation",
    value: function popupLocation() {
      var location = this.plugin.getLocation();
      if (location.includes('right')) {
        return PLACEMENTS.RIGHT;
      } else if (location.includes('left')) {
        return PLACEMENTS.LEFT;
      } else if (location.includes('top')) {
        return PLACEMENTS.TOP;
      } else {
        return PLACEMENTS.BOTTOM;
      }
    }
  }, {
    key: "convertCoordinates",
    value: function () {
      var _convertCoordinates = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data, fromProjection, toProjection) {
        var _data$lonlat3, _data$lonlat4;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.isTransformAllowed() && this.state.selectedProjection !== this.mapProjection)) {
                _context2.next = 5;
                break;
              }
              if (Oskari.util.coordinateIsDegrees([(_data$lonlat3 = data.lonlat) === null || _data$lonlat3 === void 0 ? void 0 : _data$lonlat3.lon, (_data$lonlat4 = data.lonlat) === null || _data$lonlat4 === void 0 ? void 0 : _data$lonlat4.lat])) {
                data = this.coordinatesToMetric(data);
              }
              _context2.next = 4;
              return this.getTransformedCoordinatesFromServer(data, fromProjection, toProjection);
            case 4:
              data = _context2.sent;
            case 5:
              return _context2.abrupt("return", data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function convertCoordinates(_x, _x2, _x3) {
        return _convertCoordinates.apply(this, arguments);
      }
      return convertCoordinates;
    }()
  }, {
    key: "updateLonLat",
    value: function updateLonLat(data) {
      var getDataFromServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var updateReverseGeoCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var updateEmergencyCallInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!data || !data.lonlat) {
        // update with map coordinates if coordinates not given
        data = this.getMapXY();
      }
      this.updateState({
        xy: data
      });
      if (this.isReverseGeoCode && updateReverseGeoCode) {
        this.updateReverseGeocode(data);
      }
      if (updateEmergencyCallInfo) {
        this.getEmergencyCallInfo(data);
      }
      this.updateDisplayValues(data, getDataFromServer);
    }
  }, {
    key: "updateDisplayValues",
    value: function () {
      var _updateDisplayValues = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data, getDataFromServer) {
        var _data, _data2, _data3, _data4;
        var fromServer, isSupported, isDifferentProjection, lat, lon, degreePoint;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              fromServer = false;
              if (!getDataFromServer) {
                _context3.next = 8;
                break;
              }
              _context3.next = 4;
              return this.convertCoordinates(data, this.mapProjection, this.state.selectedProjection);
            case 4:
              data = _context3.sent;
              fromServer = true;
              _context3.next = 18;
              break;
            case 8:
              if (!(this.isTransformAllowed() && this.state.selectedProjection !== this.mapProjection)) {
                _context3.next = 18;
                break;
              }
              _context3.prev = 9;
              data = transformCoordinates(this.mapModule, data, this.mapProjection, this.state.selectedProjection);
              _context3.next = 18;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](9);
              _context3.next = 17;
              return this.convertCoordinates(data, this.mapProjection, this.state.selectedProjection);
            case 17:
              data = _context3.sent;
            case 18:
              isSupported = !!(this.config && Array.isArray(this.config.supportedProjections));
              isDifferentProjection = !!(this.state.selectedProjection !== this.mapProjection && ((_data = data) === null || _data === void 0 || (_data = _data.lonlat) === null || _data === void 0 ? void 0 : _data.lat) !== 0 && ((_data2 = data) === null || _data2 === void 0 || (_data2 = _data2.lonlat) === null || _data2 === void 0 ? void 0 : _data2.lon) !== 0);
              lat = parseFloat((_data3 = data) === null || _data3 === void 0 || (_data3 = _data3.lonlat) === null || _data3 === void 0 ? void 0 : _data3.lat);
              lon = parseFloat((_data4 = data) === null || _data4 === void 0 || (_data4 = _data4.lonlat) === null || _data4 === void 0 ? void 0 : _data4.lon); // Need to show degrees ?
              if (this.isCurrentUnitDegrees() && !isNaN(lat) && !isNaN(lon)) {
                degreePoint = Oskari.util.coordinateMetricToDegrees([lon, lat], this.getProjectionDecimals());
                lon = degreePoint[0];
                lat = degreePoint[1];
              }
              // Otherwise show meter units
              else if (!isNaN(lat) && !isNaN(lon)) {
                lat = lat.toFixed(this.getProjectionDecimals());
                lon = lon.toFixed(this.getProjectionDecimals());
                lat = this.formatNumber(lat, this.decimalSeparator);
                lon = this.formatNumber(lon, this.decimalSeparator);
              }
              this.updateState({
                latField: lat,
                lonField: lon,
                approxValue: !fromServer && isSupported && isDifferentProjection
              });
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[9, 13]]);
      }));
      function updateDisplayValues(_x4, _x5) {
        return _updateDisplayValues.apply(this, arguments);
      }
      return updateDisplayValues;
    }()
  }, {
    key: "setSelectedProjection",
    value: function setSelectedProjection(projection) {
      this.updateState({
        selectedProjection: projection
      });
      this.updateDisplayValues(this.state.xy, true);
    }
  }, {
    key: "showPopup",
    value: function showPopup() {
      var _this2 = this;
      if (this.popupControls) {
        this.popupCleanup();
      } else {
        var _this$config3, _this$reverseGeocodin;
        this.popupControls = showCoordinatePopup(this.getState(), this.getController(), this.popupLocation(), (_this$config3 = this.config) === null || _this$config3 === void 0 ? void 0 : _this$config3.supportedProjections, ((_this$reverseGeocodin = this.reverseGeocodingIds) === null || _this$reverseGeocodin === void 0 ? void 0 : _this$reverseGeocodin.length) > 2, function () {
          return _this2.popupCleanup();
        });
        this.updateLonLat(this.getMapXY(), true, true, true);
        this.notifyPopupListeners(true);
      }
    }
  }, {
    key: "centerMap",
    value: function centerMap(coordinates) {
      try {
        var data = coordinates || this.state.xy;
        this.centerMapToSelectedCoordinates(data);
      } catch (e) {
        Messaging.error(this.loc('display.checkValuesDialog.message'));
      }
    }
  }, {
    key: "centerMapToSelectedCoordinates",
    value: function centerMapToSelectedCoordinates(data) {
      if (this.mapModule.isValidLonLat(data.lonlat.lon, data.lonlat.lat)) {
        this.sandbox.postRequestByName('MapMoveRequest', [data.lonlat.lon, data.lonlat.lat, this.sandbox.getMap().getZoom()]);
        this.updateLonLat(data, true, true, true);
      } else {
        Messaging.error(this.loc('display.checkValuesDialog.message'));
      }
    }
  }, {
    key: "setMarker",
    value: function setMarker() {
      var _displayData$lonlat, _data$lonlat5, _displayData$lonlat2, _data$lonlat6;
      this.centerMap();
      var data = this.state.xy || this.getMapXY();
      var displayData = {
        lonlat: {
          lon: this.state.lonField,
          lat: this.state.latField
        }
      } || this.getMapXY();
      var lat = (displayData === null || displayData === void 0 || (_displayData$lonlat = displayData.lonlat) === null || _displayData$lonlat === void 0 ? void 0 : _displayData$lonlat.lat) || (data === null || data === void 0 || (_data$lonlat5 = data.lonlat) === null || _data$lonlat5 === void 0 ? void 0 : _data$lonlat5.lat);
      var lon = (displayData === null || displayData === void 0 || (_displayData$lonlat2 = displayData.lonlat) === null || _displayData$lonlat2 === void 0 ? void 0 : _displayData$lonlat2.lon) || (data === null || data === void 0 || (_data$lonlat6 = data.lonlat) === null || _data$lonlat6 === void 0 ? void 0 : _data$lonlat6.lon);
      try {
        var msg = null;
        if (Oskari.util.coordinateIsDegrees([lon, lat]) && this.isCurrentUnitDegrees()) {
          msg = {
            lat: lat,
            lon: lon
          };
        } else {
          var _displayData$lonlat3, _displayData$lonlat4;
          msg = {
            lat: displayData === null || displayData === void 0 || (_displayData$lonlat3 = displayData.lonlat) === null || _displayData$lonlat3 === void 0 ? void 0 : _displayData$lonlat3.lat,
            lon: displayData === null || displayData === void 0 || (_displayData$lonlat4 = displayData.lonlat) === null || _displayData$lonlat4 === void 0 ? void 0 : _displayData$lonlat4.lon
          };
        }
        this.addMarker(data, msg);
      } catch (e) {
        Messaging.error(this.loc('display.checkValuesDialog.message'));
      }
    }
  }, {
    key: "addMarker",
    value: function addMarker(data, messageData) {
      var reqBuilder = Oskari.requestBuilder('MapModulePlugin.AddMarkerRequest');
      var lat = parseFloat(data.lonlat.lat);
      var lon = parseFloat(data.lonlat.lon);
      var inputLonLatData = {
        lonlat: {
          lat: lat,
          lon: lon
        }
      };

      // Check at data is given. If data is given then use for it.
      // If not then use input data's and try change data to map projection and use it to place marker
      try {
        data = data || transformCoordinates(this.mapModule, inputLonLatData, this.state.selectedProjection, this.mapProjection);
      } catch (err) {
        // Cannot transform coordinates in transformCoordinates -function
        Messaging.error(this.loc('cannotTransformCoordinates.message'));
        return;
      }
      lat = lat.toFixed(this.getProjectionDecimals());
      lon = lon.toFixed(this.getProjectionDecimals());
      if (reqBuilder) {
        var msgLon = messageData && messageData.lon ? messageData.lon : lon;
        var msgLat = messageData && messageData.lat ? messageData.lat : lat;
        var msg = msgLat + ', ' + msgLon;
        if (this.config.supportedProjections) {
          msg += ' (' + (this.loc("display.coordinatesTransform.projections.".concat(this.state.selectedProjection)) || this.state.selectedProjection) + ')';
        }
        var marker = {
          x: data.lonlat.lon,
          y: data.lonlat.lat,
          msg: msg,
          size: 5,
          color: 'ee9900',
          shape: 2
        };
        this.sandbox.request(this.plugin, reqBuilder(marker));
      }
    }
  }, {
    key: "getMapXY",
    value: function getMapXY() {
      var map = this.sandbox.getMap();
      var data = {
        lonlat: {
          lat: parseFloat(map.getY()),
          lon: parseFloat(map.getX())
        }
      };
      return data;
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(coordinate, decimalSeparator) {
      if (typeof coordinate !== 'string') {
        coordinate = coordinate + '';
      }
      coordinate = coordinate.replace('.', decimalSeparator);
      coordinate = coordinate.replace(',', decimalSeparator);
      return coordinate;
    }
  }, {
    key: "isCurrentUnitDegrees",
    value: function isCurrentUnitDegrees() {
      var projection = this.state.selectedProjection || this.mapProjection;
      var formatDef = this.getProjectionShowFormat(projection);
      var defaultedToMapmodule = formatDef || this.mapModule.getProjectionUnits();
      return defaultedToMapmodule === 'degrees';
    }
  }, {
    key: "getTransformedCoordinatesFromServer",
    value: function () {
      var _getTransformedCoordinatesFromServer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data, fromProjection, toProjection) {
        var response, newData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.setLoading(true);
              data = data || this.getMapXY();
              _context4.prev = 2;
              _context4.next = 5;
              return getTransformedCoordinates(this.mapProjection, data, fromProjection, toProjection);
            case 5:
              response = _context4.sent;
              if (!(response !== null && response !== void 0 && response.lat && response !== null && response !== void 0 && response.lon)) {
                _context4.next = 12;
                break;
              }
              newData = {
                lonlat: {
                  lon: response.lon,
                  lat: response.lat
                }
              };
              this.setLoading(false);
              return _context4.abrupt("return", newData);
            case 12:
              this.setLoading(false);
              return _context4.abrupt("return", data);
            case 14:
              _context4.next = 20;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](2);
              this.setLoading(false);
              Messaging.error(this.loc('display.cannotTransformCoordinates.message'));
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 16]]);
      }));
      function getTransformedCoordinatesFromServer(_x6, _x7, _x8) {
        return _getTransformedCoordinatesFromServer.apply(this, arguments);
      }
      return getTransformedCoordinatesFromServer;
    }()
  }, {
    key: "updateReverseGeocode",
    value: function updateReverseGeocode(data) {
      var _this3 = this;
      var service = this.service;
      if (!this.popupControls || this.state.reverseGeocodeNotImplementedError) {
        return;
      }
      if (!data || !data.lonlat) {
        // update with map coordinates if coordinates not given
        data = this.getMapXY();
      }
      var reverseGeoCode = [];
      service.getReverseGeocode(
      // Success callback
      function (response) {
        var hasResponse = !!(response && response.length > 0);
        var locale = _this3.loc('display.reversegeocode');
        // type title is not found in locales
        if (hasResponse && locale[response[0].channelId]) {
          for (var i = 0; i < response.length; i++) {
            var r = response[i];
            var title = locale[r.channelId].label;
            if (!title) {
              title = r.type;
            }
            reverseGeoCode.push({
              title: title,
              name: r.name
            });
          }
          _this3.updateState({
            reverseGeoCode: reverseGeoCode
          });
        } else {
          _this3.updateState({
            reverseGeoCode: []
          });
        }
      },
      // Error callback
      function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.status === 501) {
          _this3.updateState({
            reverseGeocodeNotImplementedError: true
          });
        }
        var messageJSON;
        try {
          messageJSON = jQuery.parseJSON(jqXHR.responseText);
        } catch (err) {}
        var message = 'Cannot reverse geocode';
        if (messageJSON && messageJSON.error) {
          message = messageJSON.error;
        }
        Oskari.log('coordinatetool').warn(message);
        _this3.updateState({
          reverseGeoCode: []
        });
      }, data.lonlat.lon, data.lonlat.lat);
    }
  }, {
    key: "getEmergencyCallCoordinatesFromServer",
    value: function () {
      var _getEmergencyCallCoordinatesFromServer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(data) {
        var sourceProjection, response, newData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // get the transform from current data
              sourceProjection = this.mapProjection; // If coordinates are not  EPSG:4326 then
              // need to get 'EPSG:4326' coordinates from service
              if (!(sourceProjection !== 'EPSG:4326')) {
                _context5.next = 16;
                break;
              }
              _context5.prev = 2;
              _context5.next = 5;
              return getTransformedCoordinates(this.mapProjection, data, sourceProjection, 'EPSG:4326');
            case 5:
              response = _context5.sent;
              if (!(response !== null && response !== void 0 && response.lat && response !== null && response !== void 0 && response.lon)) {
                _context5.next = 9;
                break;
              }
              newData = {
                lonlat: {
                  lon: response.lon,
                  lat: response.lat
                }
              };
              return _context5.abrupt("return", this.simplifyEmergencyData(newData));
            case 9:
              _context5.next = 14;
              break;
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](2);
              Messaging.error(this.loc('display.cannotTransformCoordinates.message'));
            case 14:
              _context5.next = 17;
              break;
            case 16:
              return _context5.abrupt("return", this.simplifyEmergencyData(data));
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[2, 11]]);
      }));
      function getEmergencyCallCoordinatesFromServer(_x9) {
        return _getEmergencyCallCoordinatesFromServer.apply(this, arguments);
      }
      return getEmergencyCallCoordinatesFromServer;
    }()
  }, {
    key: "getEmergencyCallInfo",
    value: function () {
      var _getEmergencyCallInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data) {
        var _this4 = this;
        var xy;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (this.config.showEmergencyCallMessage) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              // update emergency if configured
              xy = data || this.getMapXY(); // already in degrees, don't fetch again
              if (!(this.isCurrentUnitDegrees() && this.mapProjection === 'EPSG:4326')) {
                _context6.next = 7;
                break;
              }
              this.updateState({
                emergencyInfo: this.simplifyEmergencyData({
                  lonlat: {
                    lon: xy.lonlat.lon,
                    lat: xy.lonlat.lat
                  }
                })
              });
              _context6.next = 9;
              break;
            case 7:
              _context6.next = 9;
              return this.getEmergencyCallCoordinatesFromServer(data).then(function (emergencyData) {
                _this4.updateState({
                  emergencyInfo: emergencyData
                });
              });
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getEmergencyCallInfo(_x10) {
        return _getEmergencyCallInfo.apply(this, arguments);
      }
      return getEmergencyCallInfo;
    }() // just simplifying the object
  }, {
    key: "simplifyEmergencyData",
    value: function simplifyEmergencyData(data) {
      return {
        lon: data.lonlat.lon,
        lat: data.lonlat.lat
      };
    }
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this5 = this;
      var handlers = {
        /**
         * @method MouseHoverEvent
         * See PorttiMouse.notifyHover
         */
        MouseHoverEvent: function MouseHoverEvent(event) {
          if (this.state.showMouseCoordinates && !this.state.loading) {
            var data = {
              lonlat: {
                lat: parseFloat(event.getLat()),
                lon: parseFloat(event.getLon())
              }
            };
            if (event.isPaused()) {
              this.updateLonLat(data, true, true, true);
            } else {
              this.updateLonLat(data, false, false, false);
            }
          }
        },
        /**
         * @method AfterMapMoveEvent
         * Shows map center coordinates after map move
         */
        AfterMapMoveEvent: function AfterMapMoveEvent(event) {
          if (!this.popupControls) return;
          if (!this.state.showMouseCoordinates) {
            this.updateLonLat(this.getMapXY(), true, true, true);
          }
        },
        /**
         * @method MapClickedEvent
         * @param {Oskari.mapframework.bundle.mapmodule.event.MapClickedEvent} event
         */
        MapClickedEvent: function MapClickedEvent(event) {
          if (!this.popupControls) return;
          var lonlat = event.getLonLat();
          var data = {
            lonlat: {
              lat: parseFloat(lonlat.lat),
              lon: parseFloat(lonlat.lon)
            }
          };
          if (!this.showMouseCoordinates) {
            this.updateLonLat(data, true, true, true);
          }
        }
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return _this5.sandbox.registerForEventByName(_this5, p);
      });
      return handlers;
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      var handler = this.eventHandlers[e.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [e]);
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(UIHandler, ['toggleMouseCoordinates', 'isCurrentUnitDegrees', 'showPopup', 'setMarker', 'centerMap', 'setLonInputValue', 'setLatInputValue', 'setLoading', 'setSelectedProjection', 'toggleReverseGeoCode', 'useUserDefinedCoordinates', 'isMapCentered', 'popupCleanup']);
export { wrapped as CoordinatePluginHandler };